<template>
  <div>
    <!-- <loader v-if="shopSettings === null"></loader>
    <fetch-error
      v-else-if="shopSettings instanceof FetchError"
      @retry="fetchData()"
      :error="shopSettings"
    ></fetch-error> -->
    <template>
      <vue-qr
        v-if="tableNumber"
        :text="`${process.env.VUE_APP_MENU_LINK}${currentProvider.username}?table=${tableNumber}`"
        :size="500"
        :logoSrc="logo"
        :callback="test"
        margin="10"
        colorDark="#232323"
        logoBackgroundColor="transparent"
      />
      <vs-row>
        <vs-col vs-justify="center" vs-align="center" vs-w="12">
          شماره میز:
          <vs-input v-model="tableNumber" class="w-100 mt-1" />
        </vs-col>
        <vs-col>
          <div class="flex justify-end">
            <vs-button @click="download()" color="primary" class="mt-5" block
              >دریافت QR</vs-button
            >
          </div>
        </vs-col>
      </vs-row>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FetchError from "../../services/api/FetchError";
import VueQr from "vue-qr";
import TM from "../../assets/images/TM.png";

export default {
  components: {
    VueQr,
  },
  data() {
    return {
      providerInfo: null,
      tableNumber: null,
      qrFile: null,
      logo: TM,
      FetchError,
    };
  },
  computed: mapGetters({
    currentProvider: "profile/currentProvider",
  }),
  methods: {
    test(dataUrl) {
      this.qrFile = dataUrl;
    },
    download() {
      if (this.tableNumber) {
        // // Recreate Canvas Element
        // let canvas = document.createElement("canvas");
        // this.canvas = canvas;

        // // Set Canvas Context
        // let ctx = this.canvas.getContext("2d");
        // let width = 500;
        // let height = 500;

        // // Create New Image
        // let img = new Image();
        // img.src = this.qrFile;

        // // Set Canvas Height And Width According to Image Size And Scale
        // this.canvas.setAttribute("width", width);
        // this.canvas.setAttribute("height", height);

        // ctx.drawImage(img, 0, 0, width, height);
        // let base64 = this.canvas.toDataURL("image/png", 100);

        var a = document.createElement("a"); //Create <a>
        a.href = this.qrFile; //Image Base64 Goes here
        a.download = "Image.png"; //File name Here
        a.click(); //Downloaded file
      }
    },
  },
  mounted() {},
};
</script>
